import parseISO from 'date-fns/parseISO';

import { ParseToDateWithTimezone } from './types';

export const isoDateRegexpWithoutTimezone =
  /^(\d+-\d{2}-\d{2}(?:T\d{2}:\d{2}:\d{2})?).*/;

const MINUTES_PER_HOUR = 60;
const MILISECONDS_PER_HOUR = MINUTES_PER_HOUR * 60 * 1000;

const parseToDateWithTimezone = (
  isoDateString: string
): ParseToDateWithTimezone => {
  const [, dateWithoutTimezoneString] =
    isoDateRegexpWithoutTimezone.exec(isoDateString) ?? [];
  const date = parseISO(isoDateString);
  const dateWithSystemTimezone = parseISO(dateWithoutTimezoneString);
  const systemTimezone =
    -dateWithSystemTimezone.getTimezoneOffset() / MINUTES_PER_HOUR;
  const timezoneDiff =
    (dateWithSystemTimezone.getTime() - date.getTime()) / MILISECONDS_PER_HOUR;
  const timezone = systemTimezone + timezoneDiff;
  return {
    date: dateWithSystemTimezone,
    timezone,
  };
};

export default parseToDateWithTimezone;
